import React, { useEffect } from 'react';

export default function ScrollToTop({ location }) {
  const pathname = location?.pathname || '/';
  const hash = location?.hash || '';

  useEffect(() => {
    // If there's a hash, scroll to that element
    if (hash) {
      // Wait a bit for the page to render
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // Otherwise scroll to top
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
